import { render } from "./GetAllAdministrators.vue?vue&type=template&id=09783903&scoped=true"
import script from "./GetAllAdministrators.vue?vue&type=script&lang=js"
export * from "./GetAllAdministrators.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09783903"]])

export default __exports__